import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ElConfigProvider } from 'element-plus'
	import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
	
export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

	window.onload = function () {
		document.addEventListener("touchstart", function (event) {
			if (event.touches.length > 1) {
				event.preventDefault();
			}
		});
		document.addEventListener("gesturestart", function (event) {
			event.preventDefault();
		});
	};

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_unref(ElConfigProvider), { locale: _unref(zhCn) }, {
    default: _withCtx(() => [
      _createVNode(_component_router_view)
    ]),
    _: 1
  }, 8, ["locale"]))
}
}

})